import { Phone, CalendarCheck } from "lucide-react";
import { PHONE_TEL } from "@/constants/site";
import { scrollToId } from "@/lib/scroll";

export default function FloatingCallBar() {
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 gap-px border-t border-slate-200 bg-slate-200 shadow-[0_-8px_30px_rgba(15,43,72,0.15)] md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      data-testid="mobile-floating-bar"
    >
      <a
        href={PHONE_TEL}
        data-testid="mobile-floating-call-button"
        className="flex items-center justify-center gap-2 bg-rescue py-4 text-sm font-bold text-white active:bg-rescue-dark"
      >
        <Phone className="h-4 w-4" /> Call Now
      </a>
      <button
        data-testid="mobile-floating-book-button"
        onClick={() => scrollToId("request-service")}
        className="flex items-center justify-center gap-2 bg-navy py-4 text-sm font-bold text-white active:bg-navy-dark"
      >
        <CalendarCheck className="h-4 w-4" /> Book Service
      </button>
    </div>
  );
}
